(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["xclusiv-cart-savings"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-xo-discount-apply], [data-xo-discount-clear]');
  if (!button) return;
  const form = button.closest('[data-xo-discount-form]');
  const input = form.querySelector('input');
  const status = form.querySelector('[data-xo-discount-status]');
  const clearing = button.hasAttribute('data-xo-discount-clear');
  const code = clearing ? '' : input.value.trim();
  if (!clearing && !code) { input.focus(); return; }
  button.disabled = true;
  status.textContent = '';
  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({discount: clearing ? '' : [form.dataset.existingCodes, code].filter(Boolean).join(',')})
    });
    if (!response.ok) throw new Error('cart');
    const updated = await response.json();
    const applied = updated.discount_codes?.some(entry => entry.code.toLowerCase() === code.toLowerCase() && entry.applicable);
    if (clearing || applied) window.location.reload();
    else status.textContent = status.dataset.ineligible;
  } catch {
    status.textContent = status.dataset.error;
  } finally {
    button.disabled = false;
  }
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter' || !event.target.matches('[data-xo-discount-form] input')) return;
  event.preventDefault();
  event.target.closest('[data-xo-discount-form]').querySelector('[data-xo-discount-apply]').click();
});
  } catch(e) { console.error(e); }
})();

})();
